<script>
  export let item = {};
  const type_names = {
    Advisory: "Advies",
    AnnualReport: "Jaarverslag",
    File: "Bestand",
    FileAttachment: "Bestand",
    MREvent: "Oriëntatiemoment",
    Study: "Studie",
  };

  let item_type = "";
  let type_name = "";
  let is_file = false;
  let is_event = false;
  let is_study = false;
  $: {
    // This 'magically' gets run whenever 'item' changes.
    // See https://svelte.dev/tutorial/reactive-declarations
    item_type = item["@type"];
    type_name = type_names[item_type];
    is_file = (item_type === "FileAttachment" || item_type === "File");
    is_event = (item_type === "MREvent");
    is_study = (item_type === "Study");
  }
</script>

<div class="col-12 col-lg-6 col-xl-4 mb-3">
  <div class="card {item_type} h-100">
    <a href={item["@id"]}>
      {#if is_event}
      <header>
        <i class="fa fa-comments"></i> <time>{item.mina_date || ""}</time>
      </header>
      {/if}
      {#if item.getIcon}
        <img style="width: 100%" class="card-img-top" alt="Begeleidende afbeelding" src="{item["@id"]}/@@images/image/large"/>
      {:else if is_file}
        <!-- TODO Get PDF icon from somewhere. -->
        <div class="icon"><i class="flaticon-pdf17">PDF</i></div>
      {/if}
      <div class="card-body">
        <h5 class="card-title">{item.title}</h5>
        {#if item_type !== "AnnualReport"}
        <div class="card-text">
          {#if is_file}
          <!-- We have always assumed PDF -->
          <span class="discreet">
            PDF {item.getObjSize}
          </span>
          {/if}
          <p class="label">
            {type_name}
            {#if item.theme_title}
              <span>{item.theme_title}</span>
            {/if}
          </p>
          <p>
            {item.description}
          </p>
          {#if !is_event}
            <time>{item.mina_date || ""}</time>
          {/if}
        </div>
        {/if}
      </div>
    </a>
  </div>
</div>

<style lang="scss">
  a {
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }

  .label {
    font-size: 13px;
  }
  .card a .card-body time {
    color: black !important;
    font-size: 16px;
  }
  .card.MREvent {
    a {
      background-color: rgb(227, 242, 237);
      &:hover, &:focus {
        background: rgb(196, 227, 222);
        header {
          background-color: rgb(56, 125, 112);;
        }
        .card-title {
          color: darken(rgb(56, 125, 112), 50%)
        }
      }

      header {
        background-color: #4aa894;
        color: white;
        text-transform: uppercase;
        font-weight: 500;
        padding: 0.5em 1em 0.5em 1em;
        line-height: 1.1;
        h5, time {
          margin: 0;
          font-size: 16px;
          i {
            display: block;
            float: left;
            height: 1.1em;
            margin-right: 0.6em;
          }
        }
      }
      .card-body {
        .card-title {
          color: rgb(56, 125, 112);
          font-size: 15px;
          font-weight: 500;
          margin-bottom: 10px;
        }
      }
    }
  }
</style>
